import { APIRepository } from "~/context/Shared/infrastructure/APIRepository";
import { DocumentRepository } from "../domain/DocumentRepository";
import { vectiAppApiUrl } from "~/context/Shared/infrastructure/Config";
import { Criteria } from "~/context/Shared/domain/criteria/Criteria";
import { Page } from "~/context/Shared/domain/page/Page";
import { PageFull } from "~/context/Shared/domain/page/PageFull";
import { Document } from "../domain/Document";
import { SearchData } from "~/context/Shared/domain/criteria/SearchData";
import { DocumentSumIncomeOutcomeByYearMonthType } from "~/context/DocumentsData/domain/DocumentSumIncomeOutcomeByYearMonthType";
import { DocumentSumIncomeOutcomePayedByYearMonthType } from "~/context/DocumentsData/domain/DocumentSumIncomeOutcomePayedByYearMonthType";
import { DocumentDomain } from "~/context/Shared/domain/DocumentDomain";
import { ExpenseDomain } from "~/context/Shared/domain/ExpenseDomain";


export function createApiDocumentRepository(): DocumentRepository {
  return new ApiDocumentRepository();
}


export class ApiDocumentRepository extends APIRepository implements DocumentRepository {
  constructor() {
    super(vectiAppApiUrl());
  }


  async findBestMatchForMovement(companyId: string, movementId: string, tolerance: number): Promise<PageFull<Document>> {
    console.log("(API Document): findBestMatchForMovement:" + companyId + ", movement:" + movementId + ", tolerance:" + tolerance);
    const response = await this.doGet<PageFull<Document>>("/api/documents/full/bestmatch/company/" + companyId?.toString() + "/movement/" + movementId?.toString() + "/tolerance/" + tolerance?.toString());
    console.log("(API Document): " + JSON.stringify(response));
    return response;
  }

  async findNearDocumentsForMovement(companyId: string, movementId: string, criteria: Criteria): Promise<Page<Document>> {
    console.log("(API Document): llamando findNearDocumentsForMovement");
    const response = await this.getDocumentsByCompanyDistanceAndCriteria(companyId, movementId, criteria);
    return response;
  }

  async findNearDocumentsForDocument(companyId: string, documentId: string, type: string, criteria: Criteria): Promise<Page<Document>> {
    console.log("(API Document): llamando findNearDocumentsForDocument");
    const response = await this.getDocumentsFullByCompanyDistanceAndCriteria(companyId, documentId, type, criteria);
    return response;
  }


  //TODO: revisar metodos hacia abajo

  async getDocumentsByLegalId(_legalId: string): Promise<Document[]> {
    throw new Error("Method not implemented.");
    //const a = await this.doGet<Document[]>("/api/documents/company/legalId" + legalId.toString());
    //return a;
  }

  async getDocumentsByCompanyUid(companyUid: string): Promise<Document[]> {
    console.log("(ApiDocumentRepository) call getDocumentsByCompanyUid: " + companyUid.toString());
    const a = await this.doGet<Document[]>("/api/documents/company/" + companyUid.toString());
    // console.log("return getDocumentsByCompanyUid: " + JSON.stringify(a));
    return a;
  }

  async getDocumentsFullByCompanyUid(companyUid: string): Promise<Document[]> {
    console.log("(ApiDocumentRepository) call getDocumentsFullByCompanyUid: " + companyUid.toString());
    const a = await this.doGet<Document[]>("/api/documents/full/company/" + companyUid.toString());    
    return a;
  }

  async getExpensesAsDocumentsFullByCompanyUid(companyUid: string): Promise<Document[]> {
    console.log("(ApiDocumentRepository) call getExpensesAsDocumentsFullByCompanyUid: " + companyUid.toString());
    const a = await this.doGet<Document[]>("/api/documents/full/company/" + companyUid.toString() + "/type/" + DocumentDomain.EXPENSE.toString()) ;    
    return a;
  }


  async getDocumentsFullByCompanyUidDistance(companyId: string, documentId: string, type: string): Promise<Document[]> {
    const a = await this.doGet<Document[]>("/api/documents/full/company/" + companyId.toString() + "/document/" + documentId.toString() + "/type/" + type.toString());
    return a;
  }


async getPageDocumentsByCompanyTypeYearMonth(companyUid: string, documentType: string, month: string, year: string):Promise<Document[]> {
    const a = await this.doGet<Document[]>("/api/documents/company/" + companyUid.toString() + "/type/" +  documentType + "/year/" + year + "/month/" + month);
    return a;
}

async getPageIncomeDocumentsByCompanyTypeYearMonth(companyUid: string, documentType: string, month: string, year: string):Promise<Document[]> {
    const a = await this.doGet<Document[]>("/api/documents/company/" + companyUid.toString() + "/type/" +  documentType + "/year/" + year + "/month/" + month + "/income");
    return a;
}

  async getDocumentBySpotExpenseId(spotExpenseUid: string, companyUid: string): Promise<Document> {
    const a = await this.doGet<Document>("/api/documents/company/" + companyUid.toString() + "/expense/spot/" + spotExpenseUid);
    console.log("return getDocumentBySpotExpenseId: " + JSON.stringify(a));
    return a;
  }

  async getDocumentFullByIdCompanyAndType(companyUid: string, documentId: string, type:string): Promise<Document>{
    const doc = await this.doGet<Document>("/api/documents/document/full/company/" + companyUid.toString() + "/document/" + documentId.toString() + "/type/" + type.toString());
    return doc;
  }

  async getIncomeDocumentsByCompanyAndClient(companyUid: string, clientUid: string): Promise<Document[]> {
    const docs = await this.doGet<Document[]>("/api/documents/company/" + companyUid.toString() + "/client/" + clientUid.toString());
    return docs;
  }

  async getOutcomeDocumentsByCompanyAndProvider(companyUid: string, providerUid: string): Promise<Document[]> {
    console.log("getOutcomeDocumentsByCompanyAndProvider: " + companyUid + " providerUid: " + providerUid);
    const docs = await this.doGet<Document[]>("/api/documents/company/" + companyUid.toString() + "/provider/" + providerUid.toString());
    return docs;
  }

  async getOutcomeDocumentsInvoicesBillsByCompanyAndProvider(companyUid: string, providerUid: string): Promise<Document[]> {
    console.log("getOutcomeDocumentsInvoicesBillsByCompanyAndProvider: " + companyUid + " providerUid: " + providerUid);
    const docs = await this.doGet<Document[]>("/api/documents/company/" + companyUid.toString() + "/provider/" + providerUid.toString() + "/invoicesandbill"); ;
    return docs;
  }

  async getOutcomeDocumentsCreditsByCompanyAndProvider(companyUid: string, providerUid: string): Promise<Document[]> {
    console.log("getOutcomeDocumentsCreditsByCompanyAndProvider: " + companyUid + " providerUid: " + providerUid);
    const docs = await this.doGet<Document[]>("/api/documents/company/" + companyUid.toString() + "/provider/" + providerUid.toString() + "/credit"); ;
    return docs;
  }


  async getOutcomeDocumentsByCompanyAndCollaborator(companyUid: string, collaboratorUid: string): Promise<Document[]> {
    console.log("getOutcomeDocumentsByCompanyAndProvider: " + companyUid + " collaboratorUid: " + collaboratorUid);
    const docs = await this.doGet<Document[]>("/api/documents/company/" + companyUid.toString() + "/collaborator/" + collaboratorUid.toString());
    return docs;
  }

  async getOutcomeDocumentsByCompanyAndEmployee(companyUid: string, employeeUid: string): Promise<Document[]> {
    console.log("getOutcomeDocumentsByCompanyAndEmployee: " + companyUid + " employeeUid: " + employeeUid);
    const docs = await this.doGet<Document[]>("/api/documents/company/" + companyUid.toString() + "/employee/" + employeeUid.toString());
    return docs;
  }

  async getDocumentsByCompanyAndEmployee(companyUid: string, employeeUid: string): Promise<Document[]> {
    console.log("getDocumentsByCompanyAndEmployee: " + companyUid + " employeeUid: " + employeeUid);
    const docs = await this.doGet<Document[]>("/api/documents/full/company/" + companyUid.toString() + "/employee/" + employeeUid.toString());
    return docs;
  }

  async disableDocument(companyId: string, documentId: string, type:string): Promise<void>{
    const a = await this.doPostNew("/api/documents/company/disable", null, {
      companyId: companyId,
      documentId: documentId,
      type: type
    });
    return a;
  }


  async getDocumentsByCompanyUidAndCriteriaInfra(companyUid: string, criteria: Criteria): Promise<void> {
    //console.log("call getDocumentsByCompanyUid: " + companyUid.toString());

    const a = await this.doPostNew("/api/documents/company/criteria", null, {
      companyUid: companyUid,
      criteria: criteria
    });

    return a;
  }

  async getIncomeDocumentsByCompanyUid(companyUid: string): Promise<Document[]> {
    const a = await this.doGet<Document[]>("/api/documents/income/company/" + companyUid.toString());
    return a;
  }

  async getOutcomeDocumentsByCompanyUid(companyUid: string): Promise<Document[]> {
    const a = await this.doGet<Document[]>("/api/documents/outcome/company/" + companyUid.toString());
    console.log("return getOutcomeDocumentsByCompanyUid: " + JSON.stringify(a));
    return a;
  }

  async listTop10PendingIncomeInvoices(companyUid: string): Promise<Document>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<Document>("/api/documents/company/" + companyUid.toString() + "/getTop10PendingIncomeInvoice" );
    }
  }

  async listTop10OverdueOutcomeInvoices(companyUid: string): Promise<Document>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<Document>("/api/documents/company/" + companyUid.toString() + "/getTop10OverdueOutcomeInvoice" );
    }
  }

  async listTop10FutureOutcomeInvoices(companyUid: string): Promise<Document>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<Document>("/api/documents/company/" + companyUid.toString() + "/getTop10FutureOutcomeInvoice" );
    }
  }

  async listTop10FutureOutcomeDocuments(companyUid: string): Promise<Document>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<Document>("/api/documents/company/" + companyUid.toString() + "/getTop10FutureOutcomeDocument" );
    }
  }


  async listTop10FutureIncomeInvoices(companyUid: string): Promise<Document>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<Document>("/api/documents/company/" + companyUid.toString() + "/getTop10FutureIncomeInvoice" );
    }
  }

  async listTop10FutureIncomeDocuments(companyUid: string): Promise<Document>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<Document>("/api/documents/company/" + companyUid.toString() + "/getTop10FutureIncomeDocument" );
    }
  }


  async getDocumentByDocumentUidAndType(companyUid: string, documentUid: string, type: string): Promise<Document> {
    //console.log("call   getDocumentsBgetDocumentByDocumentUidAndTypeyDocumentUid: " + documentUid.toString());
    const response = await this.doGet<Document>("/api/documents/company/" + companyUid.toString() + "/document/" + documentUid.toString() + "/type/" + type.toString());
    //console.log("return getDocumentByDocumentUidAndType: " + JSON.stringify(response));
    return response;
  }

  getDocumentsFullByCompanyYearMonth(companyUid: string, year:number, month:number): Promise<Document[]> {
    return this.doGet<Document[]>("/api/documents/full/company/" + companyUid?.toString() + "/year/" + year + "/month/" + month);
  }

  getDocumentsFullByCompanyYear(companyUid: string, year:number): Promise<Document[]> {
    return this.doGet<Document[]>("/api/documents/full/company/" + companyUid?.toString() + "/year/" + year);
  }


  async getDocumentsByCompanyUidDistance(companyId: string, movementId: string): Promise<Document[]> {
    const a = await this.doGet<Document[]>("/api/documents/company/" + companyId.toString() + "/movement/" + movementId.toString());
    return a;
  }

  getDocumentsFullRepositoryBySearch(search: SearchData): Promise<Document[]> {
    return this.doPost<SearchData, Document[]>("/api/documents/full/company/search", null, search);
  }


  async getDocumentsFullByCompanyDistanceAndCriteria(companyId: string, documentId: string, type:string, criteria: Criteria): Promise<Page<Document>> {
    console.log("(ApiDocumentRepository) getDocumentsFullByCompanyDistanceAndCriteria: companyId: " + companyId + " documentId: " + documentId + " type:" + type + " criteria: " + JSON.stringify(criteria));
    const documents = await this.getDocumentsFullByCompanyUidDistance(companyId, documentId, type);
    const pageSize = criteria.pageSize;
    const start = (criteria.pageNumber - 1) * pageSize;
    let end = criteria.pageNumber * pageSize;

    const paginatedDocuments = this.filterByCriteria(criteria, documents);
    if (documents.length < (pageSize * (criteria.pageNumber + 1))) {
      end = documents.length;
    }
    console.log("(ApiDocumentRepository) getDocumentsFullByCompanyDistanceAndCriteria: paginatedInvoices length: ", paginatedDocuments.length);
    const retorno = paginatedDocuments.slice(start, end);
    console.log("(ApiDocumentRepository) getDocumentsFullByCompanyDistanceAndCriteria: retorno length: ", retorno.length);

    return Promise.resolve(
      new Page<Document>(
        paginatedDocuments.length,
        retorno
      )
    );

  }


  async getIncomeDocumentsByCompanyTypeYearMonth(companyUid: string, documentType:string, year:string, month:string, criteria: Criteria): Promise<Page<Document>>{
  try {
      const documents = await this.getPageIncomeDocumentsByCompanyTypeYearMonth(companyUid, documentType, year, month);
      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;
      const paginatedDocuments = this.filterByCriteria(criteria, documents);
      const returnpaginatedDocuments = paginatedDocuments.slice(start, end)
      console.log("getDocumentsByCompanyTypeYearMonth paginatedDocuments:" + JSON.stringify(returnpaginatedDocuments?.length));
      return Promise.resolve(
        new Page<Document>(
          returnpaginatedDocuments?.length,
          returnpaginatedDocuments
        )
      );

    } catch (error) {
      console.log("Error getDocumentsByCompanyTypeYearMonth:" + error)
      let documents = Array<Document>();
      return new Page<Document>(
        0,
        documents
      );
    }

  }

  async getDocumentsByCompanyTypeYearMonth(companyUid: string, documentType:string, year:string, month:string, criteria: Criteria): Promise<Page<Document>>{

  try {
      const documents = await this.getPageDocumentsByCompanyTypeYearMonth(companyUid, documentType, year, month);
      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;
      const paginatedDocuments = this.filterByCriteria(criteria, documents);
      const returnpaginatedDocuments = paginatedDocuments.slice(start, end)
      console.log("getDocumentsByCompanyTypeYearMonth paginatedDocuments:" + JSON.stringify(returnpaginatedDocuments?.length));
      return Promise.resolve(
        new Page<Document>(
          returnpaginatedDocuments?.length,
          returnpaginatedDocuments
        )
      );

    } catch (error) {
      console.log("Error getDocumentsByCompanyTypeYearMonth:" + error)
      let documents = Array<Document>();
      return new Page<Document>(
        0,
        documents
      );
    }


  }

  async getDocumentsFullByCompanyAndCriteria(companyUid: string, criteria: Criteria): Promise<Page<Document>> {
    try {
      const documents = await this.getDocumentsFullByCompanyUid(companyUid);
      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;
      const paginatedDocuments = this.filterByCriteria(criteria, documents);
      const returnpaginatedDocuments = paginatedDocuments.slice(start, end)
      console.log("(ApiDocumentRepository - getDocumentsFullByCompanyAndCriteria)  paginatedDocuments:" + JSON.stringify(returnpaginatedDocuments?.length));
      return Promise.resolve(
        new Page<Document>(
          paginatedDocuments?.length,
          returnpaginatedDocuments
        )
      );

    } catch (error) {
      console.log("Error getDocumentsFullByCompanyAndCriteria:" + error)
      let documents = Array<Document>();
      return new Page<Document>(
        0,
        documents
      );
    }


  }



  async getDocumentsByCompanyAndCriteria(companyUid: string, criteria: Criteria): Promise<Page<Document>> {
    try {
      const documents = await this.getDocumentsByCompanyUid(companyUid);
      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;
      const paginatedDocuments = this.filterByCriteria(criteria, documents);
      const returnpaginatedDocuments = paginatedDocuments.slice(start, end)
      console.log("(ApiDocumentRepository - getDocumentsByCompanyAndCriteria)  paginatedDocuments:" + JSON.stringify(returnpaginatedDocuments?.length));
      return Promise.resolve(
        new Page<Document>(
          returnpaginatedDocuments?.length,
          returnpaginatedDocuments
        )
      );

    } catch (error) {
      console.log("Error getFullIncomeDocumentsByCompanyClientAndCriteria:" + error)
      let documents = Array<Document>();
      return new Page<Document>(
        0,
        documents
      );
    }


  }
  /*
    async getFullDocumentsByCompanyAndCriteria(companyUid: string, criteria: Criteria): Promise<PageFull<Document>> {
      const documents = await this.getDocumentsByCompanyUid(companyUid);
      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;
      const paginatedDocuments = this.filterByCriteria(criteria, documents);
      return Promise.resolve(
        new PageFull<Document>(
          documents.length,
          paginatedDocuments.length,
          paginatedDocuments.slice(start, end)
        )
      );
    }
    */

  async getFullDocumentsByCompanyAndCriteria(companyUid: string, criteria: Criteria): Promise<PageFull<Document>> {
    let documents = Array<Document>();
    console.log("this.documentCache.length: " + this.documentCache.length);
    if (this.documentCache.length == 0) {
      documents = await this.getDocumentsByCompanyUid(companyUid);
      this.documentCache = documents;
    } else {
      documents = this.documentCache;
    }

    const pageSize = criteria.pageSize;
    const start = (criteria.pageNumber - 1) * pageSize;
    const end = criteria.pageNumber * pageSize;

    const paginatedDocuments = this.filterByCriteria(criteria, documents);
    return Promise.resolve(
      new PageFull<Document>(
        documents.length,
        paginatedDocuments.length,
        paginatedDocuments.slice(start, end)
      )
    );
  }

  async getFullIncomeDocumentsByCompanyClientAndCriteria(companyUid: string, clientUid: string, criteria: Criteria): Promise<PageFull<Document>> {
    let documents = Array<Document>();

    try {
      documents = await this.getIncomeDocumentsByCompanyAndClient(companyUid, clientUid);

      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;

      const paginatedDocuments = this.filterByCriteria(criteria, documents);
      return Promise.resolve(
        new PageFull<Document>(
          documents.length,
          paginatedDocuments.length,
          paginatedDocuments.slice(start, end)
        )
      );
    } catch (error) {
      console.log("Error getFullIncomeDocumentsByCompanyClientAndCriteria:" + error)
      return new PageFull<Document>(
        0,
        0,
        documents
      );
    }

  }

  async getDocumentsFullByCompanyYearMonthAndCriteria(companyUid: string, year:number, month:number, criteria: Criteria): Promise<Page<Document>>{
    try {
      const documents = await this.getDocumentsFullByCompanyYearMonth(companyUid, year, month);
      //const movements = await this.getMovementsFullRepositoryByCriteria(criteria);
      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;
      const paginatedDocuments = this.filterByCriteria(criteria, documents);
      console.log("paginatedDocuments: " + paginatedDocuments.length);
      console.log("pageSize: " + pageSize);
      console.log("start: " + start);
      console.log("end: " + end);
      console.log("year: " + year);
      console.log("month: " + month);
      return Promise.resolve(
        new Page<Document>(
          paginatedDocuments.length,
          paginatedDocuments.slice(start, end)
        )
      );
    } catch {
      return Promise.resolve(
        new Page<Document>(
          0,
          []
        )
      );

    }

  }


  async getDocumentsFullByCompanyYearAndCriteria(companyUid: string, year:number, criteria: Criteria): Promise<Page<Document>>{
    try {
      const documents = await this.getDocumentsFullByCompanyYear(companyUid, year);
      //const movements = await this.getMovementsFullRepositoryByCriteria(criteria);
      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;
      const paginatedDocuments = this.filterByCriteria(criteria, documents);
      console.log("paginatedDocuments: " + paginatedDocuments.length);
      console.log("pageSize: " + pageSize);
      console.log("start: " + start);
      console.log("end: " + end);
      console.log("year: " + year);
      return Promise.resolve(
        new Page<Document>(
          paginatedDocuments.length,
          paginatedDocuments.slice(start, end)
        )
      );
    } catch {
      return Promise.resolve(
        new Page<Document>(
          0,
          []
        )
      );

    }

  }


  async getFullDocumentsInvoicesBillsByCompanyProviderAndCriteria(companyUid: string, providerUid: string, criteria: Criteria): Promise<PageFull<Document>> {
    let documents = Array<Document>();

    try {
      documents = await this.getOutcomeDocumentsInvoicesBillsByCompanyAndProvider(companyUid, providerUid);

      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;

      const paginatedDocuments = this.filterByCriteria(criteria, documents);
      return Promise.resolve(
        new PageFull<Document>(
          documents.length,
          paginatedDocuments.length,
          paginatedDocuments.slice(start, end)
        )
      );
    } catch (error) {
      console.log("Error getFullDocumentsInvoiceBillByCompanyProviderAndCriteria:" + error)
      return new PageFull<Document>(
        0,
        0,
        documents
      );
    }

  }

async getDocumentsFullRepositoryByCompanySearchProviderAndCriteria(companyUid: string, search: string, providerUid: string, criteria: Criteria): Promise<PageFull<Document>>{
    let documents = Array<Document>();
//    const searchData = new SearchData(companyUid, search);
    const searchData = new SearchData(companyUid, search, providerUid, 'providers');
    try {
      documents = await this.getDocumentsFullRepositoryBySearch(searchData);
    
//      documents = await this.getOutcomeDocumentsCreditsByCompanyAndProvider(companyUid, providerUid);

      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;

      const paginatedDocuments = this.filterByCriteria(criteria, documents);
      console.log("getDocumentsFullRepositoryByCompanySearchProviderAndCriteria - paginatedDocuments.length:" + JSON.stringify(paginatedDocuments));
      return Promise.resolve(
        new PageFull<Document>(
          documents.length,
          paginatedDocuments.length,
          paginatedDocuments.slice(start, end)
        )
      );
    } catch (error) {
      console.log("Error getFullDocumentsInvoiceBillByCompanyProviderAndCriteria:" + error)
      return new PageFull<Document>(
        0,
        0,
        documents
      );
    }

}



  async getFullDocumentsCreditsByCompanyProviderAndCriteria(companyUid: string, providerUid: string, criteria: Criteria): Promise<PageFull<Document>> {
    let documents = Array<Document>();

    try {
      documents = await this.getOutcomeDocumentsCreditsByCompanyAndProvider(companyUid, providerUid);

      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;

      const paginatedDocuments = this.filterByCriteria(criteria, documents);
      return Promise.resolve(
        new PageFull<Document>(
          documents.length,
          paginatedDocuments.length,
          paginatedDocuments.slice(start, end)
        )
      );
    } catch (error) {
      console.log("Error getFullDocumentsInvoiceBillByCompanyProviderAndCriteria:" + error)
      return new PageFull<Document>(
        0,
        0,
        documents
      );
    }

  }



  async getFullOutcomeDocumentsByCompanyProviderAndCriteria(companyUid: string, providerUid: string, criteria: Criteria): Promise<PageFull<Document>> {
    let documents = Array<Document>();

    try {
      documents = await this.getOutcomeDocumentsByCompanyAndProvider(companyUid, providerUid);

      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;

      const paginatedDocuments = this.filterByCriteria(criteria, documents);
      return Promise.resolve(
        new PageFull<Document>(
          documents.length,
          paginatedDocuments.length,
          paginatedDocuments.slice(start, end)
        )
      );
    } catch (error) {
      console.log("Error getFullOutcomeDocumentsByCompanyProviderAndCriteria:" + error)
      return new PageFull<Document>(
        0,
        0,
        documents
      );
    }

  }

  async getFullOutcomeDocumentsByCompanyCollaboratorAndCriteria(companyUid: string, collaboratorUid: string, criteria: Criteria): Promise<PageFull<Document>>{
    let documents = Array<Document>();

    try {
      documents = await this.getOutcomeDocumentsByCompanyAndCollaborator(companyUid, collaboratorUid);

      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;

      const paginatedDocuments = this.filterByCriteria(criteria, documents);
      return Promise.resolve(
        new PageFull<Document>(
          documents.length,
          paginatedDocuments.length,
          paginatedDocuments.slice(start, end)
        )
      );
    } catch (error) {
      console.log("Error getFullOutcomeDocumentsByCompanyCollaboratorAndCriteria:" + error)
      return new PageFull<Document>(
        0,
        0,
        documents
      );
    }

}


  async getFullOutcomeDocumentsByCompanyEmployeeAndCriteria(companyUid: string, employeeUid: string, criteria: Criteria): Promise<PageFull<Document>> {
    let documents = Array<Document>();

    try {
      documents = await this.getOutcomeDocumentsByCompanyAndEmployee(companyUid, employeeUid);

      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;

      const paginatedDocuments = this.filterByCriteria(criteria, documents);
      return Promise.resolve(
        new PageFull<Document>(
          documents.length,
          paginatedDocuments.length,
          paginatedDocuments.slice(start, end)
        )
      );
    } catch (error) {
      console.log("Error getFullOutcomeDocumentsByCompanyEmployeeAndCriteria:" + error)
      return new PageFull<Document>(
        0,
        0,
        documents
      );
    }

  }

  async getFullDocumentsByCompanyEmployeeAndCriteria(companyUid: string, employeeUid: string, criteria: Criteria): Promise<PageFull<Document>> {
    let documents = Array<Document>();

    try {
      documents = await this.getDocumentsByCompanyAndEmployee(companyUid, employeeUid);

      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;

      const paginatedDocuments = this.filterByCriteria(criteria, documents);
      return Promise.resolve(
        new PageFull<Document>(
          documents.length,
          paginatedDocuments.length,
          paginatedDocuments.slice(start, end)
        )
      );
    } catch (error) {
      console.log("Error getFullDocumentsByCompanyEmployeeAndCriteria:" + error)
      return new PageFull<Document>(
        0,
        0,
        documents
      );
    }

  }



  async getSplitFullOutcomeDocumentsByCompanyEmployeeAndCriteria(companyUid: string, employeeUid: string, criteria: Criteria): Promise<[PageFull<Document>, PageFull<Document>]> {
    let documents = Array<Document>();
    console.log("getSplitFullOutcomeDocumentsByCompanyEmployeeAndCriteria:");
    try {
      documents = await this.getOutcomeDocumentsByCompanyAndEmployee(companyUid, employeeUid);

      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;

      const paginatedDocuments = this.filterByCriteria(criteria, documents);
      //crea dos arreglos, uno con los documentos con balance_amount>0 y otro con el resto siempre y cuando el balance no sea nulo o indefinido.

      console.log(" getSplitFullOutcomeDocumentsByCompanyEmployeeAndCriteria (paginatedDocuments):" + JSON.stringify(paginatedDocuments));

      const paginatedDocumentsNotReconciliated = paginatedDocuments.filter((document) => {
        console.log("document.document_balance: " + document.document_balance);
        console.log("condicion:" + (document.document_balance != null && document.document_balance > 0));
        if (document.document_balance != null && document.document_balance > 0) {
          return true;
        } else {
          return false;
        }
      });
      console.log(" getSplitFullOutcomeDocumentsByCompanyEmployeeAndCriteria (paginatedDocumentsNotReconciliated):" + JSON.stringify(paginatedDocumentsNotReconciliated));
      const paginatedDocumentsReconciliated = paginatedDocuments.filter((document) => document.document_balance === 0);

      return Promise.all([
        new PageFull<Document>(
          paginatedDocuments.length,
          paginatedDocumentsNotReconciliated.length,
          paginatedDocumentsNotReconciliated.slice(start, end)
        ),
        new PageFull<Document>(
          paginatedDocuments.length,
          paginatedDocumentsReconciliated.length,
          paginatedDocumentsReconciliated.slice(start, end)
        )]
      );
    } catch (error) {
      console.log("Error getFullOutcomeDocumentsByCompanyEmployeeAndCriteria:" + error)
      return [new PageFull<Document>(
        0,
        0,
        documents
      ),
      new PageFull<Document>(
        0,
        0,
        documents
      )
      ];
    }

  }








  /*
    async getFullIncomeDocumentsByCompanyAndCriteria(companyUid: string, criteria: Criteria): Promise<PageFull<Document>> {
      const documents = await this.getIncomeDocumentsByCompanyUid(companyUid);
      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;
      const paginatedDocuments = this.filterByCriteria(criteria, documents);
      return Promise.resolve(
        new PageFull<Document>(
          documents.length,
          paginatedDocuments.length,
          paginatedDocuments.slice(start, end)
        )
      );
    }
  */
  documentCache: Document[] = [];
  documentOutcomeCache: Document[] = [];
  documentIncomeCache: Document[] = [];
  cacheSize = 1000;

  async getFullIncomeDocumentsByCompanyAndCriteria(companyUid: string, criteria: Criteria): Promise<PageFull<Document>> {
    let documents = Array<Document>();
    // let documentsTMP = await this.getDocumentsByCompanyUidAndCriteriaInfra(companyUid, criteria);
    console.log("criteria page number: " + criteria?.pageNumber);
    //  console.log("documentsTMP X: " + JSON.stringify(documentsTMP));
    console.log("getFullIncomeDocumentsByCompanyAndCriteria: " + JSON.stringify(this.documentIncomeCache));
    console.log("criteria?.pageNumber === 1: " + (criteria?.pageNumber === 1));
    console.log("this.documentIncomeCache.length: " + (this.documentIncomeCache.length == 0));
    console.log("this.documentIncomeCache.length === undefined: " + (this.documentIncomeCache.length === undefined));



    if (criteria?.pageNumber === 1 || (this.documentIncomeCache.length == 0 || this.documentIncomeCache.length === undefined)) {
      console.log("no data getFullIncomeDocumentsByCompanyAndCriteria : ");
      documents = await this.getIncomeDocumentsByCompanyUid(companyUid);
      console.log("llame api:" + documents.length);
      this.documentIncomeCache = documents;
    } else {
      console.log("sin llamar  api:" + documents.length);
      documents = this.documentIncomeCache;
    }
    //let pageRetrieved = this.cacheSize / criteria.pageSize;

    const pageSize = criteria.pageSize;
    const start = (criteria.pageNumber - 1) * pageSize;
    const end = criteria.pageNumber * pageSize;
    console.log("start Y:" + start);
    console.log("end:" + end);
    const paginatedDocuments = this.filterByCriteria(criteria, documents);

    const returnpaginatedDocuments = paginatedDocuments.slice(start, end)


    console.log("paginatedDocuments:" + JSON.stringify(paginatedDocuments.length));

    //    const documents = await this.getIncomeDocumentsByCompanyUid(companyUid);

    return Promise.resolve(
      new PageFull<Document>(
        documents.length,
        returnpaginatedDocuments.length,
        returnpaginatedDocuments
      )
    );
  }


  async getFullOutcomeDocumentsByCompanyAndCriteria(companyUid: string, criteria: Criteria): Promise<PageFull<Document>> {
    let documents = Array<Document>();
    console.log("getFullOutcomeDocumentsByCompanyAndCriteria: " + this.documentOutcomeCache);
    if (criteria?.pageNumber === 1 || (this.documentOutcomeCache.length == 0 || this.documentOutcomeCache.length === undefined)) {
      documents = await this.getOutcomeDocumentsByCompanyUid(companyUid);
      console.log("llame api:" + documents.length);
      this.documentOutcomeCache = documents;
    } else {
      console.log("sin llamar  api:" + documents.length);
      documents = this.documentOutcomeCache;
    }

    const pageSize = criteria.pageSize;
    const start = (criteria.pageNumber - 1) * pageSize;
    const end = criteria.pageNumber * pageSize;
    const paginatedDocuments = this.filterByCriteria(criteria, documents);
    console.log("paginatedDocuments:" + JSON.stringify(paginatedDocuments));

    return Promise.resolve(
      new PageFull<Document>(
        documents.length,
        paginatedDocuments.length,
        paginatedDocuments.slice(start, end)
      )
    );
  }





  async getDocumentsByCompanyDistanceAndCriteria(companyId: string, movementId: string, criteria: Criteria): Promise<Page<Document>> {
    console.log("getDocumentsByCompanyDistanceAndCriteria: companyId: " + companyId + " movementId: " + movementId + " criteria: " + JSON.stringify(criteria));
    const documents = await this.getDocumentsByCompanyUidDistance(companyId, movementId);
    const pageSize = criteria.pageSize;
    const start = (criteria.pageNumber - 1) * pageSize;
    let end = criteria.pageNumber * pageSize;
    console.log("getDocumentsByCompanyDistanceAndCriteria: start: ", start, " end: ", end, " pageSize: ", pageSize, " criteria: ", JSON.stringify(criteria));
    console.log("getDocumentsByCompanyDistanceAndCriteria: + invoices length: ", documents.length);
    console.log("getDocumentsByCompanyDistanceAndCriteria: + criteria: ", (pageSize * (criteria.pageNumber + 1)));

    const paginatedDocuments = this.filterByCriteria(criteria, documents);
    if (documents.length < (pageSize * (criteria.pageNumber + 1))) {
      end = documents.length;
    }
    console.log("getDocumentsByCompanyDistanceAndCriteria: paginatedInvoices length: ", paginatedDocuments.length);
    const retorno = paginatedDocuments.slice(start, end);
    console.log("getDocumentsByCompanyDistanceAndCriteria: retorno length: ", retorno.length);

    return Promise.resolve(
      new Page<Document>(
        paginatedDocuments.length,
        retorno
      )
    );

  }



  async getDocumentsFullRepositoryByCompanyAndSearch(companyUid: string, search: string): Promise<Page<Document>> {

    const searchData = new SearchData(companyUid, search);
    console.log("getDocumentsFullRepositoryByCompanyAndSearch: companyId" + companyUid + "->" + JSON.stringify(searchData));
    const documents = await this.getDocumentsFullRepositoryBySearch(searchData);
    console.log("getDocumentsFullRepositoryByCompanyAndSearch: documents:" + JSON.stringify(documents));
    return Promise.resolve(
      new Page<Document>(
        documents.length,
        documents
      )
    );
  }


  async getDocumentsFullRepositoryByCompanySearchAndClient(companyUid: string, search: string, clientUid:string): Promise<Page<Document>> {

    const searchData = new SearchData(companyUid, search, clientUid, 'clients');
    console.log("getDocumentsFullRepositoryByCompanySearchAndClient: companyId" + companyUid + "->" + JSON.stringify(searchData));
    const documents = await this.getDocumentsFullRepositoryBySearch(searchData);
    console.log("getDocumentsFullRepositoryByCompanySearchAndClient: documents:" + JSON.stringify(documents));
    return Promise.resolve(
      new Page<Document>(
        documents.length,
        documents
      )
    );
  }

  async getDocumentsFullRepositoryByCompanySearchAndProvider(companyUid: string, search: string, providerUid:string): Promise<Page<Document>> {

    const searchData = new SearchData(companyUid, search, providerUid, 'providers');
    console.log("getDocumentsFullRepositoryByCompanySearchAndProvider: companyId" + companyUid + "->" + JSON.stringify(searchData));
    const documents = await this.getDocumentsFullRepositoryBySearch(searchData);
    console.log("getDocumentsFullRepositoryByCompanySearchAndProvider: documents:" + JSON.stringify(documents));
    return Promise.resolve(
      new Page<Document>(
        documents.length,
        documents
      )
    );
  }






  //TODO: este filtro pareciera que deberia estar en APIRepository
  filterByCriteria(
    criteria: Criteria,
    _documents: Document[]
  ): Document[] {
    //TODO: implementar filtros
    let documents = Array<Document>();
    if (criteria.filters.length > 0) {
      for (const filter of criteria.filters) {
        switch (filter.field) {
          case "company_uid": {
            if (_documents.length > 0) {
              documents = _documents.filter((document) =>
                document.company_uid.toString().toLowerCase()
                  .includes(filter.value.toLowerCase())
              );
            }
            break;
          }
          case "document_number": {
            if (_documents.length > 0) {
              documents = _documents.filter((document) =>
                document.document_number?.toLowerCase()
                  .includes(filter.value.toLowerCase())
              );
            }
            break;
          }
          case "document_type": {
            if (_documents.length > 0) {
              documents = _documents.filter((document) =>
                document.document_type
                  .toLowerCase()
                  .includes(filter.value.toLowerCase())
              );
            }
            break;
          }
          case "document_sender_legal_id": {
            if (_documents.length > 0) {
              documents = _documents.filter((document) =>
                document.document_sender_legal_id?.toLowerCase()
                  .includes(filter.value.toLowerCase())
              );
            }
            break;
          }
          case "document_receiver_legal_id": {
            if (_documents.length > 0) {
              documents = _documents.filter((document) =>
                document.document_receiver_legal_id?.toLowerCase()
                  .includes(filter.value.toLowerCase())
              );
            }
            break;
          }
          case "document_state": {
            if (_documents.length > 0) {
              documents = _documents.filter((document) =>
                document.document_state?.toLowerCase()
                  .includes(filter.value.toLowerCase())
              );
            }
            break;
          }
         case "document_origin": {
            if (_documents.length > 0) {
              documents = _documents.filter((document) => {
              if(document.document_type===DocumentDomain.INVOICE){
                if (filter.operator === "=") {
                  return document.document_origin?.toLowerCase() === filter.value.toLowerCase()                
                }
              }              
              });
            }
            break;
         }
         case "document_original_type": {
            if (_documents.length > 0) {
              documents = _documents.filter((document) => {
                if(document.document_type===DocumentDomain.EXPENSE){
                console.log("(ApiDocumentRepository) EXPENSE!!!: " + JSON.stringify(document));
                if (filter.operator === "IN") {
                  return filter.value.includes(document.document_original_type?.toLowerCase())
                }else if (filter.operator === "=") {
                  return document.document_original_type?.toLowerCase() === filter.value.toLowerCase()
                }
                return false;
                }else if(document.document_type===DocumentDomain.INVOICE){
                if (filter.operator === "IN") {
                  return filter.value.includes(document.document_original_type?.toLowerCase())
                }else if (filter.operator === "=") {
                  return document.document_original_type?.toLowerCase() === filter.value.toLowerCase()
                }
/*
                   if(document.document_original_type==='33'){
                      return true;
                   }else{
                      return false;
                    }
  */                
                }else{
                  return true;
                }
              }
              );

            console.log("(ApiDocumentRepository) document_original_type filter.value: " + filter.value);
            console.log("(ApiDocumentRepository) document_: " + JSON.stringify(_documents));
        /*
              documents = _documents.filter((document) =>
                document.document_state?.toLowerCase()
                  .includes(filter.value.toLowerCase())
              );
*/
            }
            break;
          } 
          case "document_balance": {

            if (_documents.length > 0) {
              documents = _documents.filter((document) => {
                if (filter.operator === ">") {
                  //console.log("filtrando por " + filter.operator);
                  return document.document_balance &&
                    (document.document_balance > parseInt(filter.value))
                }
                if (filter.operator === "<") {
                  return document.document_balance &&
                    (document.document_balance < parseInt(filter.value))
                }
                if (filter.operator === ">=") {
                  return document.document_balance &&
                    (document.document_balance >= parseInt(filter.value))
                }
                if (filter.operator === "<=") {
                  return document.document_balance &&
                    (document.document_balance <= parseInt(filter.value))
                }
                if (filter.operator === "=") {
                  //console.log("filtrando por " + filter.operator + " value: " + filter.value);
                  //console.log("document.document_balance  " + document.document_balance);
                  if ((document.document_balance === parseInt(filter.value))) {
                    console.log("document:  " + JSON.stringify(document));
                  }

                  return (document.document_balance === parseInt(filter.value))
                }
                return false;
              }

              );
              console.log("documents.length pre: " + documents.length);
            }

            break;
          }
          case "document_isActive": {
            console.log("document_isActive->" + JSON.stringify(filter));
            if (_documents.length > 0) {
              documents = _documents.filter((document) =>{
                if(document.document_isActive){
                  console.log("uid valido:" + document.uid);
                  return document;
                }   
              }                                
              );
            }
            break;



          }
          case "show_inflows": {
            console.log("show_inflows->" + JSON.stringify(filter));
            if (_documents.length > 0) {
              documents = _documents.filter((document) =>{
                if(document.document_type===DocumentDomain.INVOICE){    
                  if(document.document_origin==="LIBROVENTA"){
                    return document;
                  }
                }
                else if(document.document_type===DocumentDomain.EXPENSE){              
                  if(ExpenseDomain.INFLOWS.includes(document.document_original_type?.toLowerCase())){
                    return document;
                  }
                }   
              });
            }
            break;
        }
          case "show_outflows": {
            console.log("show_outflows->" + JSON.stringify(filter));
            if (_documents.length > 0) {
              documents = _documents.filter((document) =>{
                if(document.document_type===DocumentDomain.INVOICE){    
                  if(document.document_origin==="LIBROCOMPRA"){
                    return document;
                  }
                }
                else if(document.document_type===DocumentDomain.EXPENSE){              
                  if(ExpenseDomain.OUTFLOWS.includes(document.document_original_type?.toLowerCase())){
                    return document;
                  }
                }   
              });
            }
          break;
        }
      }
    }
    }
    console.log("(ApiDocumentRepository): documents.length: " + documents.length);
    return documents;
  
  }


    getIncomeOutcomeDocumentsYearMonthTypeByCompany(companyUid: string): Promise<DocumentSumIncomeOutcomeByYearMonthType>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<DocumentSumIncomeOutcomeByYearMonthType>("/api/documentsdata/company/" + companyUid.toString() + "/resumeDocumentsIncomeOutcomeByYearMonthType" );
    }
  }

    getIncomeOutcomeDocumentsPayedYearMonthTypeByCompany(companyUid: string): Promise<DocumentSumIncomeOutcomePayedByYearMonthType>{
    if (companyUid == null || companyUid == undefined || companyUid == "") {
      throw new Error("CompanyUid is null or undefined");
    } else {
      return this.doGet<DocumentSumIncomeOutcomePayedByYearMonthType>("/api/documentsdata/company/" + companyUid.toString() + "/resumeDocumentsIncomeOutcomePayedByYearMonthType" );
    }
  }

 async getExpensesAsDocumentsFullByCompanyAndCriteria(companyId: string, criteria: Criteria): Promise<Page<Document>>{
    console.log("(ApiExpenseRepository) getExpensesAsDocumentsFullByCompanyAndCriteria:" + companyId + ", criteria:" + JSON.stringify(criteria));
    try {
      const documents = await this.getExpensesAsDocumentsFullByCompanyUid(companyId);
      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;
      const paginatedDocuments = this.filterByCriteria(criteria, documents);
      const returnpaginatedDocuments = paginatedDocuments.slice(start, end)
      console.log("(ApiDocumentRepository - getExpensesAsDocumentsFullByCompanyAndCriteria)  paginatedDocuments:" + JSON.stringify(returnpaginatedDocuments?.length));
      return Promise.resolve(
        new Page<Document>(
          returnpaginatedDocuments?.length,
          returnpaginatedDocuments
        )
      );

    } catch (error) {
      console.log("Error getExpensesAsDocumentsFullByCompanyAndCriteria:" + error)
      let documents = Array<Document>();
      return new Page<Document>(
        0,
        documents
      );
    }

}

    async saveExpectedPayDate(companyId: string,documentId:string, documentExpectedPayDate:string, documentType:string, documentOrigin:string): Promise<void>{
    const documentUpdateExpectedPayDate = {
      documentId: documentId,
      companyId: companyId,
      documentExpectedPayDate: documentExpectedPayDate,
      documentType: documentType,
      documentOrigin: documentOrigin
    } as any;

    try{
      await this.doPost<any, void>("/api/documents/expectedPayDate", null, documentUpdateExpectedPayDate);
    }catch(error){
      console.log("error saveExpectedPayDate:" + error);
      throw new Error("Error: " + error);
    }
    }



}





